<template>
  <div data-component="linkWithButtonBelow">
    <template v-if="data.href.name === 'ext'">
      <a :href="data.href.url" rel="external" target="_blank">
        <span class="text">{{data.text}}</span>
        <span v-if="showOrnament" data-ornament="arrow-in-circle--right" />
      </a>
    </template>
    <template v-else>
      <router-link v-bind:to="{ name: data.href.name, params: data.href.params }">
        <span class="text">{{data.text}}</span>
        <span v-if="showOrnament" data-ornament="arrow-in-circle--right" />
      </router-link>
    </template>
  </div>
</template>

<script>
/* Component data property:
{
  text: 'Read More',  // <string>
  href: {
    name: 'matter-article', // name of route <string>
    params: {
      slug: 'article-slug', // <string>
    }
  }
*/

export default {

  props: ['data'],

  computed: {

    isDesktop() {
      return this.$store.getters.isDesktop;
    },

    showOrnament() {
      return (this.isDesktop);
    },

  },

};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-component="linkWithButtonBelow"] {
  a {
    line-height: 1;
  }

  .text {
    display: block;

    // media query props
    @include sansserif($size: (14, 14, 0), $weight: 'light');

    @include ngMq($nbp--tablet, up) {
      @include sansserif($size: (16, 16, 0), $weight: 'light');
    }
    @include ngMq($nbp--desktop, up) {
      @include sansserif($size: (20, 20, 0), $weight: 'light');
    }
  }

  [data-ornament] {
    margin-top: 1rem;
    display: inline-block;
    width: rem(46px);
  }
}

.hover--active [data-component="linkWithButtonBelow"] {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/linkWithButtonBelow.vue